module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Skrunaðu ef þörf krefur til að sjá alla reiti\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultToEmail),
      expression: "defaultToEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.defaultToEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultToEmail = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Fylltu út alla reiti merkta með \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" til að halda áfram\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("\n                            Hvernig á að finna raðnúmerið\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Það lítur út fyrir að þú sért að slá inn raðnúmer blöndunartækisins en ekki ílátið þitt. Vinsamlegast sláðu inn raðnúmer ílátsins þíns í þennan reit til að halda áfram.' : 'Engar samsvörun fundust') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Þú getur fundið raðnúmerið á svarta vírnum frá innréttingunni.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið þitt")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Raðnúmer CUBE þinnar\n                        ")]), _vm._v("\n                        Ef þú ert með CUBE kælibúnað. Finndu raðnúmerið á límmiðanum að framan, rétt fyrir neðan snertiskjáinn.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = !_vm.showCubeSerialHelper
      }
    }
  }, [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCubeSerialHelper),
      expression: "showCubeSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið þitt")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-cube.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.cube.serial),
      expression: "$store.state.form.cube.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.cube.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.cube, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eða Single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps samanstendur af bæði sjóðandi vatnskrana og aðskildum blöndunartæki frá Quooker.\n                        Stakur krani er þegar þú ert bara með sjóðandi vatnskrana frá Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Velja þarf blöndunartæki\n                        ")]) : _c('span', [_vm._v("\n                            Frekari\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Velja þarf yfirborð\n                        ")]) : _c('span', [_vm._v("\n                            Frekari\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvernig á að endurræsa Quooker\n                    ")]), _vm._v("\n                    Hægt er að leysa margar villur með einfaldri endurræsingu og endurstillingu Quooker hugbúnaðarins.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Hvernig á að endurræsa Quooker")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Það er ekki nóg bara að aftengjast!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Við mælum með því að þú reynir að ræsa Quooker rétt nokkrum sinnum áður en þú hefur samband við okkur.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Loka\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvernig blikkar Quooker blöndunartækið?\n                    ")]), _vm._v("\n                    Ef Quooker þinn finnur villu/óreglu mun ljósið á blöndunartækinu og ílátinu blikka í föstu mynstri.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("ATHUGIÐ! Í sumum tilfellum blikkar aðeins ílátið og því er mikilvægt að athuga bæði krana og ílát.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Annað / veit ekki\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blikk\n                    ")]), _vm._v("\n                    4 fljótir blikkar á blöndunartækinu eða ílátinu þýðir að hugbúnaðurinn í Quooker þínum skráir villu í tengslum við hitamælingu í Quooker þínum.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Ábending!")]), _c('br'), _vm._v("\n                    Oft er hægt að endurstilla villuna með því að gefa ílátinu svokallað „kuldasjokk“."), _c('br'), _c('br'), _vm._v("\n                    Það er gert með því að slökkva á ílátinu efst á ílátinu og tæma allt Sjóðandi vatn í ílátinu. Þegar vatnið er ekki að sjóða, láttu vatnið renna í 2 mínútur til viðbótar, svo við tryggjum að vatnið sé alveg kalt."), _c('br'), _c('br'), _vm._v("\n                    Fylgdu síðan almennu "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("endurræsingaraðferðinni")]), _vm._v(" okkar og ílátið ætti að vera tilbúið til notkunar eftir ca. 20 mínútur."), _c('br'), _c('br'), _vm._v("\n                    Það gæti verið nauðsynlegt að endurtaka þessa aðferð nokkrum sinnum."), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        Allt í lagi, ég skal reyna!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.questionIS) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(11, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse av problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nei\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valfrjálst - Hladdu upp myndum, myndskeiðum eða öðrum viðeigandi skrám ef beðið er um það<br><br><b style='font-family:AvenirHeavyOblique;'>ATHUGIÐ</b>&nbsp;&nbsp;Ef Quooker þinn hefur hljóð, munum við biðja um myndband<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>ATHUGIÐ</b>&nbsp;&nbsp;Ef Quookerinn þinn hefur orðið fyrir líkamlegum skemmdum biðjum við um myndir",
      "singleFileUploaded": "skrá hlaðið upp",
      "multipleFilesUploaded": "skrár hlaðið upp",
      "noFilesUploaded": "Engum skrám hlaðið upp",
      "addFilesButton": "Bæta við skrám",
      "remove": "Fjarlægur"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "overflow-y": "auto",
      "height": "500px",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.icelandic)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Mikilvægt!")]), _vm._v(" Ef þú hefur einhverjar spurningar skaltu svara þessum tölvupósti.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Hér að neðan finnur þú afrit af innslögðu upplýsingum þínum.\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc"
    }
  }, [_c('div', [_c('b', [_vm._v("Málsnúmer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Ílát")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('div', [_c('b', [_vm._v("CUBE")]), _vm._v(" "), _c('br'), _vm._v("\n                            Raðnúmer: " + _vm._s(_vm.$store.state.form.cube.serial) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Krani")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spurningar")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.questionIS) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Já\n                                ")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Lýsing á vandamáli")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Ábyrgð")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er varan yngri en 24 mánaða gömul?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Uppsetningardagur:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Samskiptaupplýsingar")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Fyrirtæki: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Viðhengi")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Engum skrám hlaðið upp\n                            ")])])]), _vm._v(" "), _vm._m(17)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Senda\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Viðskipti (valfrjálst)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(26)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.norwegian)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Málsnúmer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Við höfum sent þér tölvupóst þar sem málsnúmer þitt hefur verið skráð. Ef þú færð ekki þennan tölvupóst innan klukkustundar skaltu athuga hvort hann hafi endað sem ruslpóstur. Ef það er ekki til staðar, vinsamlegast hafðu samband við okkur í síma.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Hafðu samband (IS)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                Til að geta aðstoðað þig á sem bestan hátt þurfum við raðnúmer vörunnar sem fyrirspurn þín snýr að. Þú verður alltaf að slá inn raðnúmer ílátsins, jafnvel þótt beiðnin sé um blöndunartæki.\n                "), _c('br'), _c('br'), _vm._v("\n                Ef þú velur að slá inn raðnúmer allra vara getum við veitt þér bestu, hröðustu og öruggustu þjónustuna og stuðninginn.\n                "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Sláðu inn raðnúmer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Raðnúmer á ílátinu þínu "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Raðnúmer blöndunartækisins þíns "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Veldu krana\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Veldu yfirborð\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vandamál / orsök\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle fa-fw"
  }), _vm._v("\n                                Hvernig á að baka Quookerinn þinn\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Lýstu vandamálinu\n                        ")]), _vm._v("\n                        Lýstu vandamálinu eða spurningunni á reitnum hér. Ef um villu er að ræða er mikilvægt að útskýra einkennin. Hvað ertu að gera og hvað er að gerast?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Ábyrgð\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er varan yngri en 24 mánaða gömul?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Uppsetningardagur\n                        ")]), _vm._v("\n                        Veldu mánuð og ár fyrir uppsetningu\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Hengdu skrár\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Með bestu kveðjum\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Island")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Samskiptaupplýsingar\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fyrsta nafn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Eftirnafn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Tölvupóstur "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Sími "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Heimilisfang "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Póstnúmer. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Bærinn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Ég hef lesið og samþykkt Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("persónuvernd og viðskiptaskilyrði")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        SENT - Þakka þér fyrir fyrirspurn þína\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-578832a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/iceland.vue
// module id = 352
// module chunks = 1